import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mtop-01" }
const _hoisted_2 = {
  key: 2,
  class: "row gap-04 mleft-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "mtop-04 list-scroll"
}
const _hoisted_4 = { class: "row-top gap-08 w-full" }
const _hoisted_5 = {
  key: 1,
  class: "col"
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_8 = { class: "row-top gap-08 w-full" }

import { ref, computed, nextTick, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import gen from '@/functions/general.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'editDocumentFieldPreferencePanel',
  props: {
  uiSelector: { type: Object, required: true },
  initialListDataTable: { type: Array, required: true },
  initialSuggestions: { type: String, default: '' },
  initialAutoUseFirst: { type: Boolean, default: false },
},
  emits: ["persistSuggestions", "updateAutoUseFirst", "focusInput"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();

const props = __props

const emit = __emit

__expose({ insertVariable, focusInput })

const focusRef = ref(null)
const cursorPosition = ref(0)

const hasEditableText = computed(() =>
  ['TextLineUi', 'TextAreaUi', 'NumberUi'].includes(props.uiSelector.uiType)
)
const hasListUi = computed(() => ['ListUi'].includes(props.uiSelector.uiType))

const initialDataTableSnapshot = gen.deepCopy(props.initialListDataTable);
const initialSuggestionsSnapshot = gen.deepCopy(props.initialSuggestions);
const newListDataTable = ref(gen.deepCopy(props.initialListDataTable));
const newSuggestions = ref<string>(props.initialSuggestions)
const autoUseFirst = ref<boolean>(props.initialAutoUseFirst)

function saveCursorPosition() {
  const el = focusRef.value?.innerRef
  if (el) cursorPosition.value = el.selectionStart
}

function onFocus() {
  emit('focusInput')
}

function toggleAutoUseFirst() {
  autoUseFirst.value = !autoUseFirst.value
  emit('updateAutoUseFirst', autoUseFirst.value)
}

function insertVariable(key: string) {
  const text = newSuggestions.value
  const pos = cursorPosition.value
  newSuggestions.value = text.slice(0, pos) + key + text.slice(pos)
  cursorPosition.value = pos + key.length
  nextTick(() => {
    const el = focusRef.value?.innerRef
    if (el) {
      el.focus()
      el.setSelectionRange(cursorPosition.value, cursorPosition.value)
    }
  })
}

function focusInput() {
  focusRef.value?.innerRef?.focus()
}

function prescribeFullSoloList() {
  const allSelected = newListDataTable.value.every(item => item.selected === 'true')
  newListDataTable.value.forEach(row => {
    row.selected = allSelected ? 'false' : 'true'
  })
}

function listInputFct(rowIndex: number) {
  const { maxSelect, minSelect } = props.uiSelector
  const isSelected = newListDataTable.value[rowIndex].selected === 'true'
  if (isSelected) {
    // Deselecting — check minimum
    if (maxSelect > 0 && selectedCount.value <= minSelect) return
    newListDataTable.value[rowIndex].selected = 'false'
  } else {
    // Selecting
    if (maxSelect === 1) {
      newListDataTable.value.forEach(row => { row.selected = 'false' })
    }
    newListDataTable.value[rowIndex].selected = 'true'
  }
}

const selectedCount = computed(() =>
  newListDataTable.value.filter(r => r.selected === 'true').length
)

const invalidMinMax = computed(() => {
  if (!['CclListUi', 'ListUi'].includes(props.uiSelector.uiType)) return false
  const min = props.uiSelector.minSelect
  const max = props.uiSelector.maxSelect
  if (min > 0 && selectedCount.value < min) return true
  if (max > 0 && selectedCount.value > max) return true
  return false
})

const autoUseFirstLabel = computed(() => {
  switch (props.uiSelector.uiType) {
    case 'DateUi': return t('patient.document.suggestions.withConsultationDate')
    case 'ListUi': return t('patient.document.suggestions.withThisSelection')
    default:       return t('patient.document.suggestions.withFirstSuggestion')
  }
})

function persistIfDirty() {
  const oldValue = hasListUi.value
    ? JSON.stringify(initialDataTableSnapshot)
    : initialSuggestionsSnapshot
  const newValue = hasListUi.value
    ? JSON.stringify(newListDataTable.value)
    : newSuggestions.value
  if (oldValue !== newValue) {
    emit('persistSuggestions', newValue)
  }
}

onBeforeUnmount(() => {
  persistIfDirty()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_listGroup = _resolveComponent("listGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "title"),
    _createElementVNode("div", _hoisted_1, [
      (__props.uiSelector.uiType === 'BooleanUi')
        ? (_openBlock(), _createBlock(_component_switchGroup, {
            key: 0,
            active: autoUseFirst.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAutoUseFirst())),
            class: "mleft-03"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.document.suggestions.autoSelection'),
                class: _normalizeClass(autoUseFirst.value ? 'txt-white' : 'txt-primary')
              }, null, 8, ["txt", "class"])
            ]),
            _: 1
          }, 8, ["active"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.suggestions.autoUseFirst'),
              class: "mleft-04",
              styles: "main-m"
            }, null, 8, ["txt"]),
            _createVNode(_component_switchGroup, {
              active: autoUseFirst.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleAutoUseFirst())),
              class: "padButton-s mleft-04"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: autoUseFirstLabel.value,
                  class: _normalizeClass(autoUseFirst.value ? 'txt-white' : 'txt-primary')
                }, null, 8, ["txt", "class"])
              ]),
              _: 1
            }, 8, ["active"])
          ], 64)),
      (hasListUi.value && invalidMinMax.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_text_item, {
              styles: "main-alert",
              txt: _unref(t)('patient.document.suggestions.required')
            }, null, 8, ["txt"]),
            (__props.uiSelector.minSelect !== 0 && __props.uiSelector.maxSelect === 0)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 0,
                  styles: "main-alert",
                  txt: _unref(t)('patient.document.suggestions.minimum')
                }, null, 8, ["txt"]))
              : _createCommentVNode("", true),
            _createVNode(_component_text_item, {
              styles: "main-alert",
              txt: __props.uiSelector.minSelect.toString()
            }, null, 8, ["txt"]),
            (__props.uiSelector.minSelect !== __props.uiSelector.maxSelect && __props.uiSelector.maxSelect !== 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_text_item, {
                    styles: "main-alert",
                    txt: "-"
                  }),
                  _createVNode(_component_text_item, {
                    styles: "main-alert",
                    txt: __props.uiSelector.maxSelect.toString()
                  }, null, 8, ["txt"])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (hasEditableText.value)
      ? (_openBlock(), _createBlock(_component_inputBox, {
          key: 0,
          class: "mtop-05"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inputAreaAuto2, {
              ref_key: "focusRef",
              ref: focusRef,
              lines: 10,
              modelValue: newSuggestions.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newSuggestions).value = $event)),
              onBlur: saveCursorPosition,
              onFocus: onFocus
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : (hasListUi.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (__props.uiSelector.maxSelect)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(newListDataTable.value, (listRow, rowIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rowIndex,
                    class: "row"
                  }, [
                    _createVNode(_component_switchGroup, {
                      styles: "padButton-s",
                      active: listRow.selected === 'true',
                      onClick: _withModifiers(($event: any) => (listInputFct(rowIndex)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (key !== 'id' && key !== 'selected' && !key.startsWith('_'))
                                ? (_openBlock(), _createBlock(_component_text_item, {
                                    key: 0,
                                    txt: value,
                                    class: _normalizeClass(["main-m linebreak", listRow.selected === 'true' ? 'txt-white': ''])
                                  }, null, 8, ["txt", "class"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["active", "onClick"])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_listGroup, {
                    class: "pad-0 w-full",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (prescribeFullSoloList()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newListDataTable.value, (listRow, rowIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: rowIndex,
                            class: "row"
                          }, [
                            (rowIndex !== 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                              : _createCommentVNode("", true),
                            _createVNode(_component_switchGroup, {
                              styles: "padButton-s",
                              active: listRow.selected === 'true',
                              onClick: _withModifiers(($event: any) => (listInputFct(rowIndex)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      (key !== 'id' && key !== 'selected' && !key.startsWith('_'))
                                        ? (_openBlock(), _createBlock(_component_text_item, {
                                            key: 0,
                                            txt: value,
                                            class: _normalizeClass(["main-m linebreak", listRow.selected === 'true' ? 'txt-white': ''])
                                          }, null, 8, ["txt", "class"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1032, ["active", "onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})